<template>
  <div class="history-list-wrapper">
    <div class="title">
      <div style="display: flex;align-items: center;">
        <i class="title-icon iconfont icon-iconset0194"></i>
        <span class="title-label">历史诊疗</span>
      </div>
    </div>
    <el-table
      :data="tableData"
      size="small"
      @row-click="chooseTableItem"
      style="width: 100%;height: calc(100% - 80px);background-color: rgb(239,243,247)"
    >
      <!--<el-table-column prop="time" label="历史检查时间"></el-table-column>-->
      <!--<el-table-column prop="id_in_hospital" label="历史检查编号" width="180"></el-table-column>-->
      <!--<el-table-column prop="applicant" label="申请医生" width="180"></el-table-column>-->
      <el-table-column prop="date" label="时间" width="90px"></el-table-column>
      <el-table-column prop="diagnosisType" label="项目" width="50px"></el-table-column>
      <el-table-column prop="doctor_conclusion" label="诊断结果" width="80px">
        <template slot-scope="scope">
          <div class="table-item" :title="scope.row.doctor_conclusion">{{scope.row.doctor_conclusion}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="typeArr" label="其他" width="80px">
        <template slot-scope="scope">
          <div class="table-item" :title="scope.row.typeArr">{{scope.row.typeArr}}</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="mask" v-if="showDiagnoseRecord"></div>
     <diagnose-record
      v-if="showDiagnoseRecord"
      v-on:message="messagediagnoserecord"
      :allDiagnoses="diagnosesRecordList"
      :activeId="choosedTableId"
      :wordBook="wordbook"
      :id="commonData.patientId"
      :selectedDiagnosisType="selectedDiagnosisType"
    ></diagnose-record>
    <iframe hidden ref="iframePDF"></iframe>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import api from '../api';
  import axios from 'axios';
  import csrftoken from "../getToken";
  import Util from "../utils/utils.js";
  import _ from "lodash";
  import moment from 'moment';
  import DiagnoseRecord from "./DiagnoseRecord.vue";
  import {printReport} from "../utils/printReport.js";
  let template = {};
  let that;
  
  export default {
    
    components: {
      DiagnoseRecord,
    },
    mixins: [printReport],
    inject: {
      commonData: ['commonData'],
    },
    
    data() {
      return {
        wordbook: null,
        // 历史列表数据
        tableData: [],
        // 历史列表弹框的参数
        showDiagnoseRecord:false,
        choosedTableId:-1,
        diagnosesRecordList: [],
        selectedDiagnosisType: '',
        form:{}
      }
    },
    
    methods: {
      // 请求历史列表
      async getHistoryList(id) {
        try {
          let historyRes = await this.$apollo.query({
            query: gql`query patient($id: Int!) {
              patient(id: $id) {
                id
                diagnoses {
                  id
                  applicant
                  position_overview_list
                  position_detail_list
                  doctor_conclusion
                  time
                  id_in_hospital
                  ct_report_images
                  images {
                    id
                    type
                  }
                }
                hospitalization{
                  id
                  update_time
                  diagnosis
                }
                operation{
                  id
                  update_time
                  operation_position
                  relevant_info{
                    id
                    diagnosis
                  }
                  operation_releinfo_id
                }
                cosmetology{
                  id
                  update_time
                  diagnosis
                  treat_details{
                    id
                    item_info{
                      id
                      item_name
                    }
                  }
                }
              }
            }`,
            variables: {
              id,
            },
            fetchPolicy: "no-cache"
          });
          if (this.wordbook === null) {
            let res1 = await axios.request({
              method: "get",
              url: api.wordbook,
              headers: {
                "x-csrf-token": csrftoken
              },
              withCredentials: true
            });
            this.wordbook = res1.data;
          }
          this.diagnosesRecordList = historyRes.data.patient.diagnoses;
          const tableData1 = historyRes.data.patient.diagnoses
          const tableData2 = historyRes.data.patient.hospitalization;
          const tableData3 = historyRes.data.patient.operation;
          const tableData4 = historyRes.data.patient.cosmetology;
          for (let i = 0; i < tableData1.length; i++) {
            tableData1[i].diagnosisType = '影像';
            /*tableData1[i].time = moment(tableData1[i].time).format(
              "YYYY-MM-DD HH:mm"
            );*/
            tableData1[i].doctor_conclusion = this.filterConclusion(tableData1[i].doctor_conclusion);
            tableData1[i].date = moment(tableData1[i].time).format('YYYYMMDD HH:mm:ss');
            let imgs = tableData1[i].images;
            let typeArr = [];
            for (let j = 0; j < imgs.length; j++) {
              let typeString = "";
              switch (imgs[j].type) {
                case Util.SOAK.code:
                  typeString = "皮肤镜";
                  break;
                case Util.POLARRIZE.code:
                  typeString = "皮肤镜";
                  break;
                case Util.GENERAL.code:
                  typeString = "大体图/伍德灯";
                  break;
                case Util.CT.code:
                  typeString = "CT";
                  break;
                case Util.BC.code:
                  typeString = "B超";
                  break;
                case Util.PATHOlOGY.code:
                  typeString = "病理";
                  break;
              }
              typeArr.push(typeString);
            }
            typeArr = _.uniq(typeArr);
            tableData1[i].typeArr = typeArr.toString();
            if (
              tableData1[i].doctor_conclusion !== "" &&
              this.wordbook !== null
            ) {
              if (!!this.wordbook[tableData1[i].doctor_conclusion]) {
                tableData1[i].doctor_conclusion = this.wordbook[
                  tableData1[i].doctor_conclusion
                  ].name;
              }
            }
          }
          for (const item of tableData2) {
            item.diagnosisType = '住院';
            item.time = item.update_time;
            item.doctor_conclusion = this.filterConclusion(item.diagnosis);
            item.typeArr = '大体图';
            item.date = moment(item.update_time).format('YYYYMMDD HH:mm:ss');
          }
          for (const item of tableData3) {
            item.diagnosisType = '手术';
            item.time = item.update_time;
            item.doctor_conclusion = this.filterConclusion(item.relevant_info[0].diagnosis);
            item.typeArr = '-';
            item.date = moment(item.update_time).format('YYYYMMDD HH:mm:ss');
          }
          for (const item of tableData4) {
            item.diagnosisType = '美容/治疗';
            item.time = item.update_time;
            item.doctor_conclusion = this.filterConclusion(item.diagnosis);
            if (item.treat_details.length) {
              let text = '';
              for (const item1 of item.treat_details) {
                if (item1.item_info) {
                  text += ('/' + item1.item_info.item_name);
                }
              }
              item.typeArr = text.substring(1);
            }
            item.date = moment(item.update_time).format('YYYYMMDD HH:mm:ss');
          }
          const tableData = tableData1.concat(tableData2, tableData3, tableData4);
          this.tableData = tableData.sort((a, b) => {
            return b.time - a.time;
          });
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      // 根据影像诊断id查找影像诊断病名
      filterConclusion(id) {
        let name;
        // 从自定义模板中找病种名称
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
              name = data[i].name;
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (template.myTemplate) {
          f(template.myTemplate);
        }
        // 如果自定义中没有找到则在原始模板中查找
        if (!name) {
          if (that.wordbook) {
            if (that.wordbook[id]) {
              name = that.wordbook[id].name
            }
          }
        }
        return name ? name : id;
      },
      // 获取医生自定义模板
      async queryMyTemplate() {
        // 请求医生自定义的模板路径
        const res = await this.$apollo.query({
          query: gql`{
          me{
            id
            template
          }
        }`,
          fetchPolicy: 'no-cache',
        });
        // 根据路径请求模板
        const path = res.data.me.template;
        // 如果没有自定义模板
        if (path === '') {
          return;
        }
        const msg =  await axios.request({
          method: 'get',
          url: api.template + path,
        });
        template = msg.data;
      },
      chooseTableItem(row, column, event) {
        this.selectedDiagnosisType = row.diagnosisType;
       
          this.choosedTableId = row.id;
        
        this.showDiagnoseRecord = true;
      },
      // 接受诊断记录子组件传递过来的值
      messagediagnoserecord(data) {
        switch (data.type) {
          case "close":
            this.showDiagnoseRecord = false;
            break;
          case "showIntell":
            this.detail_result = data.detail_result;
            this.imgList3 = data.imgList;
            this.resiltsVisible = true;
            break;
          case "large":
            this.showLargeImage = true;
            this.largeImage = data.src;
            break;
          case "printreport":
            
            this.showSepPort = true;
       
            this.printreport_data2 = data.dinfo;
            this.printreport_images = data.data;
            this.printreport_isHostory = false;
            this.printreport_isDownLoad = data.isDownLoad;
            this.printreport_advise = data.advise;
            let ii = data.form;
            this.form.id = ii.id;
            this.form.created_time = moment(ii.created_time).format('YYYY-MM-DD');
            this.form.id_in_hospital = ii.id_in_hospital;
            this.form.birthday = ii.birthday === this.initialTime ? '' :
              moment(ii.birthday).format('YYYY-MM-DD');
            this.form.age = ii.age > -1 ? (ii.age + '') : '';
            this.form.id_card_number = ii.id_card_number;
            this.form.phone = ii.phone;
            this.form.profession = ii.profession;
            this.form.gender = ii.gender;
            this.form.name = ii.name;
            this.form.race = ii.race;
            this.form.skin_color = ii.skin_color;
            this.form.address = ii.address;
            this.form.idCardNumber = ii.id_card_number;
            this.form.nativePlace = ii.native_place;
            this.form.country = ii.country;
            this.form.email = ii.email;
            this.printreport_data = this.form;
            this.PrintSubmit();
        
            break;
        }
      },
    },
    
    async mounted() {
      this.$root.$on('getHistoryList', () => {
        this.getHistoryList(this.commonData.patientId);
      });
      that = this;
      await this.queryMyTemplate();
      // 如果是继续治疗就填上患者信息
      if (this.$store.state.continueTreatData.status) {
        this.$store.commit('addContinueTreatStatusCount');
        const timer = setInterval(() => {
          if (this.commonData.patientId > -1) {
            clearInterval(timer);
            this.getHistoryList(this.commonData.patientId);
          }
        }, 200);
      }
      // 如果是点击编辑跳转过来
      if (this.$store.state.modifyCosmetologyData.status) {
        this.$store.commit('addModifyCosmetologyStatusCount');
        const timer = setInterval(() => {
          if (this.commonData.patientId > -1) {
            clearInterval(timer);
            this.getHistoryList(this.commonData.patientId);
          }
        }, 200);
      }
      // 如果是点击患者列表跳转过来
      if (this.$store.state.cosmetologyData.status) {
        this.$store.commit('addCosmetologyStatusCount');
        const timer = setInterval(() => {
          if (this.commonData.patientId > -1) {
            clearInterval(timer);
            this.getHistoryList(this.commonData.patientId);
          }
        }, 200);
      }

      // console.log("In CommonHistoryList:");
      // console.log("this.$store.state.continueTreatData.statusCount:",this.$store.state.continueTreatData.statusCount);
      // console.log("this.$store.state.modifyCosmetologyData.statusCount:",this.$store.state.modifyCosmetologyData.statusCount);
      // console.log("this.$store.state.cosmetologyData.statusCount:",this.$store.state.cosmetologyData.statusCount);
    },
    
    beforeDestroy() {
      this.$root.$off('getHistoryList');
    },
  
  }
</script>

<style lang="less">
  .history-list-wrapper .el-table__body-wrapper{
    height: calc(100% - 40px);
    overflow-y: auto;
  }
  .history-list-wrapper .el-table th{
    color: #61a2bf !important;
    background-color: inherit !important;
    font-weight: bold !important;
  }
  .history-list-wrapper .el-table tr{
    background-color: inherit !important;
  }
  .history-list-wrapper .cell{
    word-break: break-word !important;
    text-align: center !important;
  }

</style>
<style lang="less" scoped>
  .history-list-wrapper{
    height: 100%;
    padding: 0 5px;
    .title {
      display: flex;
      justify-content: space-between;
      width: 100%;
      color: #48a3c2;
      font-size: 16px;
      border-bottom: 2px solid #48a3c2;
      padding-top: 10px;
      padding-bottom: 10px;
      margin-bottom: 10px;
      overflow: hidden;
      height: 25px;
      text-align: left;
      align-items: center;
      .title-icon{
        font-size:24px;
        margin-right:10px;
      }
      .title-label{
        white-space: nowrap;
        font-size: 18px;
      }
    }
  }
  .mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
  .table-item{
    overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }
</style>
